import { PropsWithChildren, createContext, useContext } from "react";
import { TourismoPageData } from "~/types";

const PageContext = createContext<TourismoPageData | null>(null);

type Props = {
  value?: TourismoPageData | null;
};

export const PageContextProvider = ({
  value = null,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <PageContext.Provider value={value}>{children}</PageContext.Provider>
  );
};
export const usePageContext = () => useContext(PageContext);
